import MessageLayout from '@components/MessageLayout';
import useAuth from '@contexts/AuthProvider';
import { useRegisterContext } from '@contexts/RegisterProvider';
import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export const ResumeRedeemCode: React.FC = () => {
  const navigate = useNavigate();
  const { tokenParsed } = useAuth();
  const { registrationCode, updateRegistrationCode } = useRegisterContext();

  const tokenRegistrationCode = tokenParsed?.initial_registration_code as string | undefined;

  useEffect(() => {
    if (tokenRegistrationCode && tokenRegistrationCode !== registrationCode) {
      updateRegistrationCode(tokenRegistrationCode);
    }

    if (registrationCode || tokenRegistrationCode) {
      void navigate('/redeem');
    } else {
      void navigate('/');
    }
  }, [navigate, registrationCode, tokenRegistrationCode, updateRegistrationCode]);

  return <MessageLayout icon={<CircularProgress size={32} />} />;
};
